import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountEmailConfirmSend" })
export default class AccountEmailConfirmSend extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public formData: any = {};
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        
        this.isLoading = true;

        try {
            let response = await Axios.post(this.routes.Account_EmailConfirmSend, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } });
            let result = response.data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }
};